<a [routerLink]="'/'" class="header-home-box" target="_blank">
  <span>berufsreise.at</span>
  <brt-icon [icon]="'link-1'"></brt-icon>
</a>
